import { CSSProperties } from 'react';
import { useTranslation } from 'react-i18next';

import { formatNumberWithSeparators } from 'common/utils/functions';

export type KioskCardStatisticsItem = {
  title: string;
  value: string | number;
  isPercent?: boolean;
  subvalue?: string | number;
};

interface Props {
  items?: KioskCardStatisticsItem[];
  className?: string;
  style?: CSSProperties
}

const KioskCardStatistics = ({ items = [], className, style }: Props) => {
  const { t } = useTranslation();

  return (
    <div className={`t-kioskCardStatistics${className ? ` ${className}` : ''}`} style={style}>
      {items.map((item) => (
        <div className="t-kioskCardStatistics_item" key={item.title}>
          <div className="t-kioskCardStatistics_title">
            {item.title}
            :
          </div>
          <div className="t-kioskCardStatistics_valueWrapper">
            <span className="t-kioskCardStatistics_value">
              {typeof item.value === 'number' ? formatNumberWithSeparators(item.value) : item.value}
              {item.isPercent && <span className="t-kioskCardStatistics_percent">%</span>}
            </span>
            {item.subvalue ? (
              <span className="t-kioskCardStatistics_subvalue">
                {' '}
                (
                {typeof item.subvalue === 'number' ? formatNumberWithSeparators(item.subvalue) : item.subvalue}
                {' '}
                {t('dashboard.turns')}
                )
              </span>
            ) : null}
          </div>
        </div>
      ))}
    </div>
  );
};

export default KioskCardStatistics;
